module.exports = __webpack_public_path__ + "assets/images/05B.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/05B.png
// module id = 1260
// module chunks = 1